import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GlobalSettingsDAEngineerState } from './global-settings.reducer';

export const selectGlobalSettingsFeature =
  createFeatureSelector<GlobalSettingsDAEngineerState>(
    'global-settings-da-engineer'
  );

export const selectGlobalSettingsValueRecognitionForm = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.globalSettingsValueRecognitionForm
);

export const selectAllMandatoryChecksTemplates = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.mandatoryChecksTemplates
);

export const selectMandatoryCheckTemplateForm = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.mandatoryCheckTemplateForm
);

export const selectAllPhases = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.allPhases
);

export const selectAllPeerPoolDisciplines = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.peerPoolDisciplines
);

export const selectPeerPoolDisciplineForm = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.peerPoolDisciplineForm
);

export const selectDADeliverableTemplates = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.daDeliverableTemplates
);

export const selectDADeliverableTemplateForm = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.daDeliverableTemplateForm
);

export const selectFocusAreaConfigs = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.focusAreaConfigs
);

export const selectFocusAreaConfigForm = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.focusAreaConfigForm
);

export const selectSMEDisciplineConfigCodes = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.smeDisciplineConfigCodes
);

export const selectAllBusinessUnits = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.businessUnits
);

export const selectBusinessUnitForm = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.businessUnitForm
);

export const selectAllAssignments = createSelector(
  selectGlobalSettingsFeature,
  (state) => state.allAssignments
);
